import { gql } from "graphql-tag"

const homeVideos = gql`
  type Query {
    getHomeVideos(query: GetQueryHomeVideos): [HomeVideoSearchItem]!
    getHomeVideoById(id: ID!): HomeVideo
    searchHomeVideos(
      searchHomeVideosInput: SearchHomeVideosInput!
    ): [HomeVideoSearchItem]
  }
`

export default homeVideos
